// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerContent":"Footer_footerContent__GLsTv","newsLetter":"Footer_newsLetter__DzDH3"};